import React, { useState } from 'react';
import {
  Box,
  Button,
  FormControlLabel,
  Menu,
  RadioGroup,
  Typography,
} from '@mui/material';
import { useTheme } from "@mui/material/styles";
import { makeStyles } from '@material-ui/styles';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import BpRadio from './BpRadio';

const useStyles = makeStyles({
  radioLabel: {
    fontSize: '14px',
  },
});

export default function FilterButton({ onClick }) {
  const theme = useTheme();
  const classes = useStyles();
  const [anchorNotification, setAnchorNotification] = useState(null);
  const [bookingStatus, setBookingStatus] = useState(-1);

  function handleClick(event) {
    setAnchorNotification(event.currentTarget);
  }

  const handleClose = () => () => {
    setAnchorNotification(null);
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Button
        onClick={(e) => handleClick(e)}
        variant="contained"
        color="primary"
        sx={{ color: '#fff', fontWeight: 600, padding: '10px 30px', textTransform: 'none' }}
        startIcon={<FilterAltIcon />}
      >
        Filter
      </Button>
      <Menu
        sx={{ mt: '45px' }}
        anchorEl={anchorNotification}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorNotification)}
        onClose={handleClose()}
        PaperProps={{
          sx: {
            ".MuiList-root": { padding: '0!important', minWidth: '300px' }
          },
        }}
      >
        <Typography
          sx={{
            color: theme.palette.mode === 'light' ? '#181c32' : '#fff',
            fontWeight: '600',
            borderBottom: '1px solid #ccc',
            paddingTop: '16px',
            paddingBottom: '16px',
            paddingLeft: '24px',
          }}
        >
          Filter Options
        </Typography>
        <Box sx={{ flexDirection: 'column', paddingLeft: '24px', paddingTop: '16px' }}>
          <Typography sx={{ color: theme.palette.mode === 'light' ? '#181c32' : '#fff', fontWeight: '500', fontSize: '14px' }}>Booking Status</Typography>
          <RadioGroup
            defaultValue="trial"
            aria-labelledby="demo-customized-radios"
            name="customized-radios"
            value={bookingStatus}
            onChange={(e) => setBookingStatus(e.target.value)}
            sx={{ marginTop: '8px' }}
          >
            <FormControlLabel value={-1} control={<BpRadio size="18px" />} label="All" classes={{ label: classes.radioLabel }} />
            <FormControlLabel value={0} control={<BpRadio size="18px" />} label="Pending" classes={{ label: classes.radioLabel }} />
            <FormControlLabel value={2} control={<BpRadio size="18px" />} label="Approved" classes={{ label: classes.radioLabel }} />
            <FormControlLabel value={1} control={<BpRadio size="18px" />} label="Declined" classes={{ label: classes.radioLabel }} />
          </RadioGroup>
        </Box>
        <Box display="flex" justifyContent="flex-end" padding="16px">
          <Button
            onClick={handleClose()}
            size="large"
            sx={{
              backgroundColor: theme.palette.mode === 'light' ? '#f5f8fa' : '#2b2b40',
              color: theme.palette.mode === 'light' ? '#7e8299' : '#6d6d80',
              fontWeight: 500,
              textTransform: 'none',
              borderRadius: '6px',
              padding: '8px 20px',
              "&:hover": {
                backgroundColor: theme.palette.mode === 'light' ? '#f1faff' : '#212E48',
                color: '#009ef7',
              },
            }}
          >
            Reset
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => {
              handleClose()();
              onClick(bookingStatus);
            }}
            sx={{ marginInlineStart: 1, color: '#fff', fontWeight: 600, textTransform: 'none' }}
          >
            Apply
          </Button>
        </Box>
      </Menu>
    </Box>
  );
}
